import React from 'react';
import { DonutCard } from './DonutCard.component';
import styles from '../DashboardOverviewNew.module.scss';

const EMPTY_SEGMENT = [{ name: '—', pct: 100, time: '—', color: '#E5E7EB' }];

const FOCUS_VS_DISTRACTION_TOOLTIP = {
  description:
    'Compares time spent in apps marked as focus/productivity tools against everything else, capped at your active time for the day.',
  calculation: {
    formula: 'Focus % = Focus-app time / Total tracked time × 100',
  },
};

export const FocusVsDistraction = ({ data, isLoading = false }) => {
  const { focusPct, label, segments } = data || {
    focusPct: 0,
    label: '—',
    segments: EMPTY_SEGMENT,
  };

  return (
    <DonutCard
      className={styles.quarterCard}
      isLoading={isLoading}
      title="Focus vs Distraction"
      tooltip={FOCUS_VS_DISTRACTION_TOOLTIP}
      chartSize={130}
      innerRadius={52}
      outerRadius={62}
      segments={segments.map((seg) => ({
        name: seg.name,
        value: seg.pct,
        color: seg.color,
        displayValue: `${seg.time} (${seg.pct}%)`,
      }))}
      centerValue={`${focusPct}%`}
      centerLabel={label}
    />
  );
};
